/* TODO: t() */
import React, { Fragment, useState, useEffect } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { useQuery } from '@tanstack/react-query';

import { Page, Picker, ButtonToolbar, IconWithText, Text } from '../uiold';
import { themeColors } from '../uiold/Constants';
import { useFetchJson } from '../../support/useFetch';

import { EditorStateProvider } from './EditorContext';
import { FormElementListWithFetch } from './FormElementList';
import SubmissionList from './SubmissionList';

import { Market } from '../../types/shared/Market';
import {
  FormSubmission,
  FormSubmissionByDate,
  FormSubmissions,
} from '../../types/shared/FormSubmission';

import { Link } from '../Navigation';

function SubmissionPage() {
  let fetchJson = useFetchJson();
  let [selectedMarket, setSelectedMarket] = useState<Market | null>(null);
  let [
    selectedSubmission,
    setSelectedSubmission,
  ] = useState<FormSubmission | null>(null);
  let [blankPageMessage, setBlankPageMessage] = useState<JSX.Element | null>(
    null,
  );

  let { data: markets } = useQuery(['markets'], () => {
    return fetchJson<Array<Market>>(
      '/api/markets',
      null,
      (data) => data.markets,
    );
  });

  let { data: dataSubmissions } = useQuery(
    ['forms/evaluation/submissions'],
    () => {
      return fetchJson<FormSubmissions>('/api/forms/evaluation/submissions');
    },
  );

  const pageHeader = 'Submissions';

  useEffect(() => {
    if (dataSubmissions && markets && !selectedMarket) {
      let { submissions } = dataSubmissions;
      let marketsWithSubmissions = markets.filter(
        (market: Market) => !!submissions[market.id],
      );

      if (markets.length === 0) {
        setBlankPageMessage(
          <Text type="label">
            {"You don't have any market dates. "}
            <Link to={['/markets']} variant="blue">
              Add a new market
            </Link>
            .
          </Text>,
        );
      } else if (marketsWithSubmissions[0]) {
        setSelectedMarket(marketsWithSubmissions[0]);
        setBlankPageMessage(null);
      } else {
        setBlankPageMessage(
          <Text type="label">
            {'No markets with submissions. '}
            <Link to={['/market-metrics/form']} variant="blue">
              Make a new submission
            </Link>
            .
          </Text>,
        );
      }
    }
  }, [markets, dataSubmissions, selectedMarket]);

  if (markets == null || dataSubmissions == null) {
    return <Page isLoading={true} />;
  }

  let { submissions } = dataSubmissions;

  if (blankPageMessage) {
    return (
      <Page>
        <Page.Header title={pageHeader} />
        <View style={styles.root}>{blankPageMessage}</View>
      </Page>
    );
  }

  let submissionsByDate: FormSubmissionByDate = {};
  if (selectedMarket) {
    submissionsByDate = submissions[selectedMarket?.id] || {};
  }

  let marketsWithSubmissions = markets.filter(
    (market: Market) => !!submissions[market.id],
  );

  return (
    <Page>
      <Page.Header title={pageHeader} />
      <View style={selectedSubmission && styles.hidden}>
        <ButtonToolbar style={styles.toolbar}>
          <Picker
            options={marketsWithSubmissions}
            selectedItem={selectedMarket}
            onChange={setSelectedMarket}
          />
        </ButtonToolbar>
        <SubmissionList
          submissionsByDate={submissionsByDate}
          setSelectedSubmission={setSelectedSubmission}
        />
      </View>
      {selectedSubmission && (
        <Fragment>
          <TouchableOpacity onPress={() => setSelectedSubmission(null)}>
            <IconWithText
              iconName="arrowBack"
              text="Back to list"
              color={themeColors.mainNavText}
              style={styles.back}
            />
          </TouchableOpacity>
          <EditorStateProvider
            value={{ register: null, submission: selectedSubmission }}
          >
            <FormElementListWithFetch
              selectedSubmission={selectedSubmission}
              mode="readOnly"
            />
          </EditorStateProvider>
        </Fragment>
      )}
    </Page>
  );
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  back: {
    marginBottom: 8,
  },
  toolbar: {
    zIndex: 1,
    marginBottom: 8,
  },
  hidden: {
    display: 'none',
  },
});

export default SubmissionPage;
